import { storeToRefs } from 'pinia'
import { useMqttStore } from '@/store/mqttStore'
import { MqttValue, MqttMessage } from '../mqttDefinitions'
import {
  handlebarCurrentPositionX,
  handlebarCurrentPositionY,
  saddleCurrentPositionX,
  saddleCurrentPositionY,
} from '@/mqttDefinitions'
import { MqttTopic } from '@/mqttDefinitions/topics'

const translations = new Map<string, any>()

translations.set(
  MqttTopic.MOTORCONTROLLER_SADDLE_X_CURRENT_SETPOINT,
  saddleCurrentPositionX,
)
translations.set(
  MqttTopic.MOTORCONTROLLER_SADDLE_Y_CURRENT_SETPOINT,
  saddleCurrentPositionY,
)
translations.set(
  MqttTopic.MOTORCONTROLLER_HANDLEBAR_X_CURRENT_SETPOINT,
  handlebarCurrentPositionX,
)
translations.set(
  MqttTopic.MOTORCONTROLLER_HANDLEBAR_Y_CURRENT_SETPOINT,
  handlebarCurrentPositionY,
)

export default class {
  static async publish(definition: MqttValue, newValue: number) {
    const reply = translations.get(definition.topic)

    if (reply) {
      const mqttStore = useMqttStore()
      const { client } = storeToRefs(mqttStore)

      const message = {
        topic: reply.topic,
        payload: newValue,
      } as MqttMessage

      if (client.value.connected) {
        try {
          let preSubmitOutput

          if (reply.preSubmitFunction) {
            preSubmitOutput = reply.preSubmitFunction(
              message,
              reply.conversionValue,
            )
          } else {
            preSubmitOutput = {
              topic: message.topic,
              payload: JSON.stringify({
                value: message.payload,
              }),
            }
          }

          await client.value.publish(
            preSubmitOutput.topic,
            preSubmitOutput.payload,
          )
        } catch (error) {
          console.warn('Publish error', error)
        }
      }
    }
  }
}
